/*-----------------------------------------------------------------
- Comments From
-----------------------------------------------------------------*/
export default {
    no_comment: 'هیچ دیدگاهی ثبت نشده!',

    message: {
        success: 'نظر شما با موفقیت ارسال شد.',
        error  : 'مشکل در ثبت',
    },
};
